///////////////////////////////////////////////////////////////
// components/LoanResults.jsx
import React, { memo } from 'react';

const LoanResults = ({ formData }) => {
  return (
    <div className="mb-3 rounded-xl border border-yellow-200 bg-yellow-50/80 p-3 sm:p-4 md:mb-6 md:p-5">
      <h3 className="mb-2 text-base font-semibold text-yellow-700 sm:text-lg md:mb-4 md:text-xl">RESULTADOS</h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 sm:gap-3 md:gap-4">
        {/* Importe de Cuota */}
        <div className="flex flex-col">
          <label className="mb-1 text-xs font-medium text-slate-700 sm:text-sm md:mb-2">IMPORTE DE CUOTA</label>
          <div className="relative">
            <span className="absolute left-3 top-1/2 -translate-y-1/2 text-sm text-slate-500">S/</span>
            <input 
              name="cuota" 
              type="text" 
              value={formData.cuota} 
              readOnly
              className="w-full rounded-xl border border-yellow-300 bg-white py-2 pl-8 pr-3 font-bold text-yellow-800" 
            />
          </div>
        </div>
        {/* Total a Pagar */}
        <div className="flex flex-col">
          <label className="mb-1 text-xs font-medium text-slate-700 sm:text-sm md:mb-2">TOTAL A PAGAR</label>
          <div className="relative">
            <span className="absolute left-3 top-1/2 -translate-y-1/2 text-sm text-slate-500">S/</span>
            <input 
              name="total" 
              type="text" 
              value={formData.total} 
              readOnly
              className="w-full rounded-xl border border-yellow-300 bg-white py-2 pl-8 pr-3 font-bold text-yellow-800" 
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default memo(LoanResults);
